export const MY_CREDIT_LOGS = 'MY_CREDIT_LOGS';
export const MY_CREDIT = 'MY_CREDIT';
export const LIST_PARTNER_PACKAGE = 'LIST_PARTNER_PACKAGE';
export const GET_USERAFF_INFO = 'GET_USERAFF_INFO';
export const PARTNER_UPGRADE_STORE = 'PARTNER_UPGRADE_STORE';
export const LIST_STORE = 'LIST_STORE';
export const LIST_ORDER_DETAIL = 'LIST_ORDER_DETAIL';
export const ACTIVE_STORE = 'ACTIVE_STORE';